import _regeneratorRuntime from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/inherits";
import { BaseClient, BaseResponse } from './base';
var FetchResponse = /*#__PURE__*/function (_BaseResponse) {
  _inherits(FetchResponse, _BaseResponse);
  /**
   * BaseResponse facade for fetch API Response
   * @param {Response} response
   */
  function FetchResponse(response) {
    var _this;
    _classCallCheck(this, FetchResponse);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FetchResponse).call(this));
    _this.response = response;
    return _this;
  }
  _createClass(FetchResponse, [{
    key: "getHeader",
    value: function getHeader(name) {
      return this.response.headers.get(name);
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.response.arrayBuffer) {
                  _context.next = 6;
                  break;
                }
                _context.next = 3;
                return this.response.arrayBuffer();
              case 3:
                _context.t0 = _context.sent;
                _context.next = 9;
                break;
              case 6:
                _context.next = 8;
                return this.response.buffer();
              case 8:
                _context.t0 = _context.sent.buffer;
              case 9:
                data = _context.t0;
                return _context.abrupt("return", data);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }()
  }, {
    key: "status",
    get: function get() {
      return this.response.status;
    }
  }]);
  return FetchResponse;
}(BaseResponse);
export var FetchClient = /*#__PURE__*/function (_BaseClient) {
  _inherits(FetchClient, _BaseClient);
  function FetchClient(url, credentials) {
    var _this2;
    _classCallCheck(this, FetchClient);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(FetchClient).call(this, url));
    _this2.credentials = credentials;
    return _this2;
  }
  _createClass(FetchClient, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _ref,
          headers,
          credentials,
          signal,
          response,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, headers = _ref.headers, credentials = _ref.credentials, signal = _ref.signal;
                _context2.next = 3;
                return fetch(this.url, {
                  headers: headers,
                  credentials: credentials,
                  signal: signal
                });
              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", new FetchResponse(response));
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function request() {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }]);
  return FetchClient;
}(BaseClient);